import { gql } from '@apollo/client';

export const JOB_POSITION_FOR_LIST_FRAGMENT = gql`
  fragment JobPositionForList on JobPosition {
    applicationProcess
    beds
    canStartDate
    canStartNow
    contractTypes {
      id
      title
    }
    departments {
      id
      name
    }
    employer {
      averagePeriod
      beds
      careType
      logoKey
      id
      gallery
      name
      status
      allowInitiativeApplications
      organisation {
        id
        allowInitiativeApplicationsPaused
      }
      overtimeCompensations {
        id
        title
      }
      patients
      salaryNegotiations {
        id
        title
      }
      showSalary
      typesLeasingEmployer
    }
    employmentTypes
    fullTimeHours
    geoLocation {
      administrativeAreaLevel1
      administrativeAreaLevel2
      administrativeAreaLevel3
      administrativeAreaLevel4
      administrativeAreaLevel5
      country
      city
      formattedAddress
      id
    }
    headline
    id
    numberOfDoctors
    salaryHigh
    salaryLow
    salaryLastChangedAt
    showSalary
    status
    jobTitles {
      id
      title
      trackingPriority
      city
    }
    isInitiative
    title
    slug
    updatedAt
    createdAt
    vacationDays
  }
`;
